import { RobotStateContext } from "../hooks/useRobotState";
import type { RobotStateProviderProps } from "../hooks/useRobotState";

/**
 * Provides the per-session `RobotState` instance (created by `useOperatorSession`) to
 * the whole UI subtree so hooks/components read business state through `useRobotState()`.
 */
export function RobotStateProvider({ robotState, children }: RobotStateProviderProps) {
  return <RobotStateContext.Provider value={robotState}>{children}</RobotStateContext.Provider>;
}
